"use strict";
/*
 * Created on 17. 7. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Conversion of {@link OptimizationGraph}.
 * @author Radek Beran
 */


var OptimizationGraphConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(OptimizationGraphConverter, _DataObjectConverter_);

  function OptimizationGraphConverter() {
    _classCallCheck(this, OptimizationGraphConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(OptimizationGraphConverter).apply(this, arguments));
  }

  return OptimizationGraphConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.OptimizationGraphConverter = OptimizationGraphConverter;